
class Config {
  constructor() {
      this._nodeEnv = process.env.NODE_ENV;
  }
  get FulfillmentCustomizationApiUrl() {
      return process.env.FULFILLMENT_CUSTOMIZATION_ENDPOINT;
  }
  get PackingSlipApiUrl() {
      return process.env.PACKING_SLIP_ENDPOINT;
  }
  get FrontEndAppSettingsApiUrl() {
    return process.env.FRONT_END_APP_SETTINGS_API_URL;
  }
  // Only for tests
  /**
   * @param {string} value
   */
   set NodeEnvironment(value) {
      this._nodeEnv = value;
  }
}

const configService = new Config();

export default configService;